import {TemplateRCDataFromRequest} from 'core/RateConfirmation/types';

export const isDriverDetails = (data: TemplateRCDataFromRequest): boolean => data?.is_show_driver_details;
